'use client'

import { useEffect } from 'react'

import { useLocalizedRouter } from '@src/hooks/useLocalizedRouter'

/**
 * Redirects to a new URL declaratively.
 * @param url - The URL to redirect to.
 * @param skeleton - The skeleton to render while redirecting.
 * @returns The skeleton or null.
 */
export function Redirect({ url, skeleton }: { url: string; skeleton?: React.ReactNode }) {
  const router = useLocalizedRouter()
  useEffect(() => router.replace(url), [url, router])
  return skeleton ?? null
}
